import { useMemo } from 'react'

import { useAppContext } from 'app/useAppContext'
import { useObject } from 'data/hooks/objects'
import { doesFieldTypeMatch } from 'data/utils/ts_utils'

export type FieldOptions = {
    // field api_name
    value: string
    // field label
    label: string
}

/**
 * Returns list of fields from users table which "type match" to the given field and return them in options format
 *  (suitable for filtering or other API usage)
 *
 * Type matched fields have the same field type and in case of relational fields, they point to the same target object
 *
 * @param field The field to get user profile field options for
 * @returns List of field options
 */
export const useUserFieldOptionsForDefaultValues = (field: FieldDto): FieldOptions[] => {
    const { selectedStack } = useAppContext()
    const { object: userObject } = useObject(selectedStack?.options?.data_mapping?.user_object)

    const memoizedOptions = useMemo(() => {
        const userObjFields = [...(userObject?.fields ?? [])]

        const options = userObjFields
            .filter(
                (userField) =>
                    !userField.connection_options?.is_disabled &&
                    doesFieldTypeMatch(field, userField)
            )
            .map((x) => ({
                value: x.api_name,
                label: x.label,
            }))

        return options
    }, [field, userObject])

    return memoizedOptions
}
